import { Component, computed, effect, inject, untracked } from '@angular/core';

import { LangPipe, LangService, RouteWatcher, SeoService } from '@reforgium/presentia';

import { BackToTopComponent } from 'components/back-to-top';

import { DictService } from 'use-cases/dict.service';
import { FilterPanel } from 'features/panels/filter-panel';

import { TaxCodeShortcutComponent } from './components/tax-code-shortcut.component';
import { TaxLegislationCardComponent } from './components/tax-legislation-сard.component';

@Component({
  selector: 'app-tax-legislation-component',
  template: `
    <section class="legislation-home">
      <div class="intro flex-col md:flex-row">
        <h1>«Салык Кеңеш» —</h1>
        <p>{{ 'document.intro' | lang }}</p>
      </div>
      <img class="hero-art" src="assets/bg/Illustration.png" alt="" />
      <app-filter-panel isFullWidth />

      <app-tax-code-shortcut />

      <h2 class="title-m title">{{ 'document.titles.categories' | lang }}</h2>
      <div class="container-cards">
        @if (categories().length) {
          @for (categoryItem of categories(); track categoryItem.id) {
            <app-tax-legislation-card [name]="categoryItem.name" [id]="categoryItem.id" />
          }
        } @else {
          @for (_ of [].constructor(12); track $index) {
            <app-tax-legislation-card isSkeleton />
          }
        }
      </div>
      <app-back-to-top />
    </section>
  `,
  imports: [FilterPanel, LangPipe, TaxCodeShortcutComponent, TaxLegislationCardComponent, BackToTopComponent],
  styles: `
    .legislation-home {
      position: relative;
    }
    .intro {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 1rem;
      margin-bottom: 20px;
    }
    .intro h1 {
      font-size: calc(30px * var(--a11y-font-scale, 1));
      font-weight: 500;
      line-height: 1.2;
      margin: 0 0 2px;
    }
    .intro p {
      font-size: calc(14px * var(--a11y-font-scale, 1));
      color: var(--text-secondary);
      max-width: calc(100% - 200px);
    }
    .hero-art {
      position: absolute;
      right: 0;
      top: -8px;
      width: 230px;
      height: 220px;
      object-fit: contain;
      pointer-events: none;
    }
    app-filter-panel {
      position: relative;
      z-index: 1;
      width: calc(100% - 190px);
    }
    .title {
      margin-top: 22px;
      font-size: calc(12px * var(--a11y-font-scale, 1));
      font-weight: 400;
      color: var(--text-secondary);
    }
    .container-cards {
      margin: 12px 0 24px;
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      gap: 8px;
    }
    @media (max-width: 1100px) {
      .container-cards {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }
    @media (max-width: 700px) {
      .hero-art {
        display: none;
      }
      app-filter-panel {
        width: 100%;
      }
      .intro p {
        max-width: 100%;
      }
      .container-cards {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
    @media (max-width: 420px) {
      .container-cards {
        grid-template-columns: 1fr;
      }
    }
  `,
  providers: [SeoService],
})
export class TaxLegislationComponent {
  seoService = inject(SeoService);
  dictService = inject(DictService);
  langService = inject(LangService);
  routeWatcher = inject(RouteWatcher);

  categories = computed(() => {
    this.langService.currentLang();

    return this.dictService.categories.items();
  });

  constructor() {
    effect(() => {
      const { lang } = this.routeWatcher.query();
      const preparedLang = ['kg', 'KG', 'ky', 'KY'].includes(lang) ? 'ky' : 'ru';

      untracked(() => this.langService.setLang(preparedLang));
    });
    effect(() => {
      const categories = this.categories();

      if (categories.length) {
        this.seoService.setKeywords(categories.map((categoryItem) => categoryItem.name));
      }
    });
    // TODO: add KG language
    this.seoService.setTitle('Налоговое законодательство');
    this.seoService.setDescription('Главная страница сайта');
    // TODO: get description from BA
    this.seoService.setTwitter({
      title: 'Налоговое законодательство',
      description: 'Главная страница сайта',
    });
  }
}
